import Flickity from 'flickity';
import playVideos from '../services/helpers';

// general carousel options
const carouselOptions = {
    // options
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    pauseAutoPlayOnHover: false,
    lazyLoad: true,
};
// initialize splash carousel
const splashCarousel = document.querySelector('.js-splash-carousel');
const splashFlkty = new Flickity(splashCarousel, {
    ...carouselOptions,
    autoPlay: 9000,
});

splashFlkty.on('select', () => {
    // https://davidwalsh.name/offsetheight-visibility
    const videoIsVisisble = splashFlkty.selectedElement.querySelector('video').offsetHeight;
    if (videoIsVisisble > 0) {
        playVideos(splashFlkty);
    }
});
// initialize display carousel
const displaysCarousel = [...document.querySelectorAll('.js-display-carousel')];

// initiate display carousel after DOM load/ready
displaysCarousel.forEach((displayCarousel) => {
    /* eslint-disable no-bitwise, no-plusplus */
    for (let i = displayCarousel.children.length; i >= 0; i--) {
        displayCarousel.appendChild(displayCarousel.children[Math.random() * i | 0]);
    }
    /* eslint-disable no-unused-vars */
    const displayFlkty = new Flickity(displayCarousel, {
        autoPlay: 11000,
        ...carouselOptions,
    });
});



// WEBPACK FOOTER //
// ./src/js/methods/sliders.js